export default __webpack_public_path__ + "static/media/reverse_fly_start.9d2f37aa.svg";